module.exports = __webpack_public_path__ + "static/media/Clover-Xuesong-Zhou.649bb2f0.jpg";